import { render, staticRenderFns } from "./Openings.vue?vue&type=template&id=594a3e20"
import script from "./Openings.vue?vue&type=script&lang=js"
export * from "./Openings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports